export default __webpack_public_path__ + "static/media/Activities.c7ba3870.webp";